import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuditLog, AuditLogFilter, AuditLogPage } from 'src/app/models/AuditLog';
import { environment } from 'src/environments/environment';

/**
 * Trilha de auditoria dos cadastros — somente administrador
 * (AUDIT_LOGS_PROPOSTA.md, seção 9).
 */
@Injectable({ providedIn: 'root' })
export class AuditLogService {

  constructor(private http: HttpClient) { }

  list(
    page: number = 1,
    perPage: number = 15,
    filter: AuditLogFilter = {}
  ): Observable<AuditLogPage> {
    let params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);

    // Filtro vazio não vai na query: o backend trataria '' como filtro inválido
    // em campos como `owner_user_id` (uuid).
    Object.keys(filter).forEach((key) => {
      const value = (filter as any)[key];
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        params = params.set(key, String(value).trim());
      }
    });

    return this.http.get<AuditLogPage>(`${environment.apiUrl}/audit-logs`, { params });
  }

  find(id: string): Observable<AuditLog> {
    return this.http.get<AuditLog>(`${environment.apiUrl}/audit-logs/${id}`);
  }
}
